import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth";
import { onAttendanceRefresh } from "../attendanceEvents";
import api from "../api";

const NAV = [
  { id:"checkin",     ic:"→]", label:"Check In / Out", feat:"checkin"   },
  { id:"attendance",  ic:"▦",  label:"Attendance",     feat:"attendance" },
  { id:"history",     ic:"≡",  label:"History",        feat:"history"    },
  { id:"leaves",      ic:"✈",  label:"Leaves",         feat:"leaves"     },
  { id:"timesheet",   ic:"⏱",  label:"Timesheet",      feat:"timesheet"  },
  { id:"direct_call", ic:"☎",  label:"Direct Call",    feat:"direct_call"},
  { id:"team",        ic:"⊞",  label:"Team",           feat:"team"       },
  { id:"leave_admin", ic:"🗓",  label:"Leave Admin",    feat:"_admin"     },
  { id:"reports",     ic:"📊",  label:"Reports",        feat:"_admin"     },
  { id:"admin",       ic:"⚙",  label:"Admin",          feat:"_admin"     },
  { id:"salary",      ic:"$",  label:"Salary Slips",   feat:null         },
  { id:"profile",     ic:"●",  label:"Profile",        feat:null         },
];

function SidebarTimer() {
  const [info,   setInfo]  = useState(null);
  const [, setTick] = useState(0);

  const loadAttendance = () => {
    const now   = new Date();
    const month = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}`;
    const today = now.toISOString().slice(0,10);
    api.get(`/portal/attendance?month=${month}`)
      .then(d => { const day = d.days?.[today]; if (day?.first_in && day.first_in !== "-") setInfo(day); })
      .catch(()=>{});
  };

  useEffect(() => {
    loadAttendance();
    const poll = setInterval(loadAttendance, 30000);
    const unsub = onAttendanceRefresh(loadAttendance);
    return () => { clearInterval(poll); unsub(); };
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTick(n => n+1), 1000);
    return () => clearInterval(t);
  }, []);

  if (!info) return null;

  const parseHMS = s => {
    if (!s || s === "-") return null;
    const [h,m,sec] = s.split(":").map(Number);
    const d = new Date(); d.setHours(h, m, sec||0, 0); return d;
  };

  const inT   = parseHMS(info.first_in);
  const outT  = parseHMS(info.last_out !== "-" ? info.last_out : null);
  const isOut = info.last_action === "checkout" && outT;
  const ref   = isOut ? outT : new Date();
  const diff  = inT ? Math.max(0, (ref - inT) / 1000) : 0;
  const hh = Math.floor(diff/3600), mm = Math.floor((diff%3600)/60), ss = Math.floor(diff%60);
  const fmt = n => String(n).padStart(2,"0");

  return (
    <div className="sidebar-timer">
      <div className="label">{isOut ? "TODAY'S HOURS" : "TIME SINCE CHECK-IN"}</div>
      <div className="time">{fmt(hh)}:{fmt(mm)}:{fmt(ss)}</div>
      <div className="sub">In {info.first_in}{isOut ? ` · Out ${info.last_out}` : ""}</div>
    </div>
  );
}

export default function Sidebar({ basePath = "/portal" }) {
  const { me, logout, has, anyAdmin } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [photo,   setPhoto]  = useState(null);

  useEffect(() => {
    if (me?.has_photo) {
      api.get("/portal/photo", { responseType:"blob" })
        .then(blob => blob instanceof Blob && setPhoto(URL.createObjectURL(blob)))
        .catch(()=>{});
    }
  }, [me]);

  const parts = location.pathname.split("/"); const current = parts[parts.length-1] || "checkin";

  const visible = item => {
    if (!me) return false;
    if (item.feat === "_admin") return anyAdmin();
    if (!item.feat) return true;
    return has(item.feat);
  };

  return (
    <nav className="sidebar">
      <div className="brand"><b>INVINCIBLE</b> · HR</div>
      <div style={{flex:1}}>
        {NAV.filter(visible).map(item => (
          <button key={item.id}
            className={`nav-item ${current===item.id?"active":""}`}
            onClick={() => navigate(`${basePath}/${item.id}`)}>
            <span className="ic">{item.ic}</span>{item.label}
          </button>
        ))}
      </div>
      <div className="sidebar-bottom">
        <SidebarTimer />
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            {photo ? <img src={photo} alt="avatar"/> : (me?.first_name?.[0]||"?").toUpperCase()}
          </div>
          <div>
            <div style={{fontWeight:600,fontSize:13}}>{me?.name}</div>
            <div style={{fontSize:11,color:"var(--muted)"}}>{me?.employee_id}</div>
          </div>
        </div>
        <button className="nav-item" style={{color:"var(--danger)"}} onClick={logout}>Log out</button>
      </div>
    </nav>
  );
}
